import { LipaBidhaaPageHeader } from "../components/LipaBidhaa/shared/LipaBidhaaPageHeader";
import { PaymentFlowContainer } from "../components/LipaBidhaa/shared/PaymentFlowContainer";
import { PAYMENT_TYPES } from "../components/LipaBidhaa/config/lipaBidhaaConfig";

function Paykit() {
  return (
    <div className="p-6">
      <LipaBidhaaPageHeader />
      <PaymentFlowContainer paymentType={PAYMENT_TYPES.B2B} />
    </div>
  );
}

export default Paykit;
